import styles from "./lead-form.module.scss";
import Select from "react-select";
import { ReactComponent as LeftIcon } from "assets/caretleft.svg";
import { useEffect, useState, useRef } from "react";
import { phoneMask } from "helpers/masks";
import { isValidEmail, validatePhone } from "helpers/validators";
import useExternalApiService from "helpers/ExternalApiService";
import { store } from "stores/Store";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { useNavigate } from "react-router-dom";
import { splitFirstAndLastName } from "helpers";
import SlideUpMenus from "Modules/SlideUpMenus";
import DuplicateConfirmationModal from "Modules/CreateLead/components/DuplicateConfirmationModal";
import { Tab } from "Modules/PractitionerBaseballCard";
import ConfirmationModal from "components/ConfirmationModal/ConfirmationModal";
import { Box, Button, CheckIcon } from "@mantine/core";
import GeoValidationDrawer from "components/GeoValidationDrawer";
import { logEvent } from '@amplitude/analytics-browser';
import { useRegions } from "helpers/useRegionHook";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { openPractitionerListDrawer } from "components/PractitionerListDrawer";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
type View = "submit" | "draft" | "lead" | "backedit";

const MOCK_SPECIALTIES = [
  "RWS",
  "BCHN",
  "BS in Exercise Kinesiology",
  "BS Nutrition",
  "CCN",
  "CNC",
  "CNS",
  "CTNC",
  "DC",
  "Dentist",
  "DO",
  "DOM",
  "DPM",
  "DSS-Health Coach",
  "DSS-RN",
  "DVM",
  "FDN",
  "International",
  "LAc",
  "LPC/LCSW",
  "MD",
  "Midwife",
  "MS Nutrition",
  "NANP Professional",
  "ND",
  "NTP",
  "Nurse Practitioner",
  "OD",
  "Other",
  "PA",
  "Pharmacist",
  "PhD/PsyD",
  "PT/DPT",
  "RD",
  "RN"
];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const STATES = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA",
  "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD",
  "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
  "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC",
  "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"
];

const COUNTRIES = [
  // { label: "Argentina", value: "AR" },
  { label: "Australia", value: "AU" },
  // { label: "Belgium", value: "BE" },
  // { label: "Bulgaria", value: "BG" },
  // { label: "Brazil", value: "BR" },
  { label: "Canada", value: "CA" },
  // { label: "Switzerland", value: "CH" },
  // { label: "Chile", value: "CL" },
  // { label: "Colombia", value: "CO" },
  // { label: "Czechia", value: "CZ" },
  // { label: "Germany", value: "DE" },
  // { label: "Denmark", value: "DK" },
  // { label: "Estonia", value: "EE" },
  // { label: "Spain", value: "ES" },
  // { label: "Finland", value: "FI" },
  // { label: "France", value: "FR" },
  // { label: "United Kingdom", value: "GB" },
  { label: "United States", value: "US" },
  // { label: "Croatia", value: "HR" },
  // { label: "Hungary", value: "HU" },
  // { label: "Ireland", value: "IE" },
  // { label: "India", value: "IN" },
  // { label: "Italy", value: "IT" },
  // { label: "Japan", value: "JP" },
  // { label: "Lithuania", value: "LT" },
  // { label: "Luxembourg", value: "LU" },
  // { label: "Latvia", value: "LV" },
  // { label: "Mexico", value: "MX" },
  // { label: "Malaysia", value: "MY" },
  // { label: "Netherlands", value: "NL" },
  // { label: "Norway", value: "NO" },
  // { label: "New Zealand", value: "NZ" },
  // { label: "Poland", value: "PL" },
  { label: "Puerto Rico", value: "PR" },
  // { label: "Portugal", value: "PT" },
  // { label: "Sweden", value: "SE" },
  // { label: "Singapore", value: "SG" },
  // { label: "Slovenia", value: "SI" },
  // { label: "Slovakia", value: "SK" },
];

const MOCK_PRACTICE_TYPE = [
  "Private Practice",
  "Hospital",
  "Pharmacy",
  "Fitness / Health Club",
  "Med Spa / Aesthetics",
  "Online Platform",
  "Educational Organization",
  "Sports Team",
  "Dental Office",
  "Students",
  "Other",
  "Specialty Retail"
];

interface PractionerLeadForm {
  name: string;
  phone: string;
  specialtyType: string;
  email: string;
  practiceType: string;
  status: string;
  primary_name: string;
  fmc_email: string;
  firstname: string;
  lastname: string;
  companyname: string;
  address1: string;
  address2: string;
  city: string;
  state: any; // Changed from string to any to accommodate react-select object
  zipcode: string;
  readyToPurchase: boolean;
  latLon?: [number, number];
  country: any;
  website: string;
}

const getSplittedLineAddress = (n = "") => {
  if (!n) {
    return ["", ""];
  }
  const result = n.split("\n");
  if (result && result.length >= 2) {
    return [result[0], result[1]];
  }
  if (result && result.length === 1) {
    return [result[0], ""];
  }
  return ["", ""];
}

type GeoValidationAction = "validate" | "draft" | "";

const MAX_NAME_SIZE = 30;

interface Props {
  practitionerInfo?: any;
  onFormStateChange: (s: boolean) => void;
  onFormSubmitted: () => void;
  onNavigate?: (v: string) => void;
  onViewDuplicate?: () => void;
}
const LeadForm: React.FC<Props> = ({ practitionerInfo, onFormStateChange, onFormSubmitted, onNavigate, onViewDuplicate }) => {
  const [_firstname, _lastname] = splitFirstAndLastName(practitionerInfo?.name || practitionerInfo?.place?.name);
  const [_address1, _address2] = getSplittedLineAddress(practitionerInfo?.address);
  const stateFromPlaces = practitionerInfo?.place?.address_components?.find((a: any) => a?.types?.includes("administrative_area_level_1"))?.short_name;

  const address1FromPlaces = (practitionerInfo?.place?.address_components?.find((a: any) => a?.types?.includes("street_number"))?.long_name || "") + " " + (practitionerInfo?.place?.address_components?.find((a: any) => a?.types?.includes("route"))?.long_name || "");
  const address2FromPlaces = practitionerInfo?.place?.address_components?.find((a: any) => a?.types?.includes("subpremise"))?.long_name || ""

  const [form, setForm] = useState<PractionerLeadForm>({
    phone: practitionerInfo?.place?.formatted_phone_number || practitionerInfo?.phone || "",
    name: practitionerInfo?.name || `${_firstname} ${_lastname}` || "",
    primary_name: practitionerInfo?.name || `${_firstname} ${_lastname}` || "",
    specialtyType: practitionerInfo?.specialty ?
      { label: practitionerInfo?.specialty, value: practitionerInfo?.specialty } as any :
      practitionerInfo?.place?.types[0],
    practiceType: practitionerInfo?.practice_type ?
      { label: practitionerInfo?.practice_type, value: practitionerInfo?.practice_type } as any : "",
    email: practitionerInfo?.email || "",
    status: "LEAD-INCOMPLETE",
    fmc_email: store.impersonatedUser || "",
    firstname: practitionerInfo?.firstname || _firstname?.slice(0, MAX_NAME_SIZE),
    lastname: practitionerInfo?.lastname || _lastname?.slice(0, MAX_NAME_SIZE),
    companyname: practitionerInfo?.companyname || practitionerInfo?.place?.name || "",
    city: practitionerInfo?.city || practitionerInfo?.place?.address_components?.find((a: any) => a?.types?.includes("locality"))?.long_name ||
      practitionerInfo?.place?.address_components?.find((a: any) => a?.types?.includes("administrative_area_level_2"))?.long_name,
    state: practitionerInfo?.state ?
      { label: practitionerInfo?.state, value: practitionerInfo?.state } as any :
      { label: stateFromPlaces || "", value: stateFromPlaces || "" } as any,
    zipcode: practitionerInfo?.zipcode || practitionerInfo?.place?.address_components?.find((a: any) => a?.types?.includes("postal_code"))?.long_name,
    address1: _address1 || address1FromPlaces,
    address2: _address2 || address2FromPlaces,
    country: practitionerInfo?.place?.address_components?.find((a: any) => a?.types?.includes("country"))?.short_name || practitionerInfo?.country || store.impersonatedUserCountry || "US",
    readyToPurchase: Boolean(practitionerInfo?.ready_to_purchase),
    latLon: (practitionerInfo?.latitude && practitionerInfo?.longitude)
      ? [practitionerInfo?.latitude, practitionerInfo?.longitude]
      : undefined,
    website: practitionerInfo?.website || practitionerInfo?.place?.website || "",
  });
  const [formState, setFormState] = useState<Partial<PractionerLeadForm>>({});
  const [isSlideUpMenusOpen, setIsSlideUpMenusOpen] = useState(false);
  const [isDuplicateModalOpen, setIsDuplicateModalOpen] = useState(false);

  const apiUrl = process.env.REACT_APP_EAI_URL;
  const { putData, postData } = useExternalApiService(apiUrl);
  const [alreadyConfirmed, setAlreadyConfirmed] = useState(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const isValid = Object.keys(formState).length === 0;
  const [geoValidationAction, setGeoValidationAction] = useState<GeoValidationAction>("");
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const isEditMode = !!practitionerInfo?.id;
  const regions = useRegions(form.country);
  const [isGeoValidated, setIsGeoValidated] = useState(
    (practitionerInfo?.place?.geometry.location.lat && practitionerInfo?.place?.geometry.location.lng) ||
    (form?.latLon?.length === 2) || (practitionerInfo?.latitude && practitionerInfo?.longitude)
  );

  const isProgrammaticUpdate = useRef(false);


  useEffect(() => {
    if (practitionerInfo?.latitude && practitionerInfo?.longitude) {
      isProgrammaticUpdate.current = true;
    } else {

      if (form.firstname) {
        setTimeout(() => {
          handleGeoValidation("validate");
        }, 300);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isProgrammaticUpdate.current) {

      setIsGeoValidated(false);
    } else {

      isProgrammaticUpdate.current = false;
    }
  }, [form.address1, form.address2, form.city, form.state, form.zipcode, form.country]);
  useEffect(() => {
    if (alreadyConfirmed) {
      submitLead(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alreadyConfirmed]);

  useEffect(() => {
    const errObj: { [k: string]: string } = {};

    if (!form.lastname.trim()) {
      errObj["lastname"] = "empty";
    }
    if (form.lastname.trim().length > MAX_NAME_SIZE) {
      errObj["lastname"] = "length exceeded";
    }

    if (!form.firstname.trim()) {
      errObj["firstname"] = "empty";
    }
    if (form.firstname.trim().length > MAX_NAME_SIZE) {
      errObj["firstname"] = "length exceeded";
    }

    if (!form.address1) {
      errObj["address1"] = "empty";
    }
    /*
    if (!form.specialtyType) {
      errObj["specialtyType"] = "empty";
    }
    if (!form.practiceType) {
      errObj["practiceType"] = "empty";
    }
    */
    if (!isValidEmail(form.email)) {
      console.log("!isValidEmail=", !isValidEmail(form.email));
      errObj["email"] = "invalid";
    }

    if (!validatePhone(form.phone, form.country)) {
      errObj["phone"] = "invalid";
    }

    if (!isGeoValidated) {
      errObj["address1"] = "invalid";
      console.log("practitionerInfo", practitionerInfo)
    }
    setFormState(errObj);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form, isGeoValidated]);

  useEffect(() => {
    onFormStateChange(isValid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isValid]);

  const handleOpenBaseballCard = () => {
    setIsDuplicateModalOpen(false);
    setAlreadyConfirmed(false);
    if (onViewDuplicate) {
      onViewDuplicate();
    }
  };

  const handleCloseDuplicateModal = () => {
    setIsDuplicateModalOpen(false);
    setAlreadyConfirmed(false);
  };

  const getPractitionerNotDraftByEmail = async (email: string) => {
    const result = await postData(`/api/get_practitioner_not_draft_by_email`, {
      "email": email
    });

    // Ensure the practitioner has general_notes field
    if (result && result.practitioner) {
      result.practitioner.general_notes = result.practitioner.general_notes || '';
    }

    return result;
  }

  const handleGeoValidation = (action: GeoValidationAction = "validate") => {
    setGeoValidationAction(action);
  };

  const submitLead = async (isDraft: boolean = false, f?: PractionerLeadForm) => {
    if (!isDraft && !alreadyConfirmed) {
      setIsConfirmationModalOpen(true);
      return;
    }
    if (!f) {
      f = form;
    }
    try {
      let result;
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      let newPractitionerInfo;
      if (practitionerInfo?.id) {
        const _status = !isDraft ? "LEAD-AWAITING-NETSUITE" :
          (isValid ? 'LEAD-READY2SUBMIT' : 'LEAD-INCOMPLETE');
        newPractitionerInfo = {
          address: `${f.address1}\n${f.address2}\n${f?.city}, ${(f?.state as any)?.value} ${f?.zipcode}`,
          address1: `${f.address1}`,
          address2: `${f.address2}`,
          phone: f.phone,
          name: `${f.firstname} ${f.lastname}`,
          primary_name: `${f.firstname} ${f.lastname}`,
          firstname: f.firstname,
          lastname: f.lastname,
          companyname: f.companyname,
          specialty: (f.specialtyType as any)?.value,
          practice_type: (f.practiceType as any)?.value,
          email: f.email,
          status: _status,
          data_source: "SALES ASSISTANT",
          fmc_email: store.impersonatedUser,
          latitude: practitionerInfo?.place?.geometry.location.lat || (f?.latLon ? f.latLon[0] : undefined),
          longitude: practitionerInfo?.place?.geometry.location.lng || (f?.latLon ? f.latLon[1] : undefined),
          city: f.city,
          state: (f.state as any)?.value,
          country: f.country || practitionerInfo?.place?.address_components?.find((a: any) => a?.types?.includes("country"))?.short_name,
          // building_name: f.building_name,
          // sub_locality: f.sub_locality,
          zipcode: f.zipcode,
          fmc: store.impersonatedUserName,
          fmc_netsuite_id: store.impersonatedUserNetsuiteID,
          rsd: store.impersonatedUserRsdName,
          rsd_email: store.impersonatedUserRsdEmail,
          stage: "LEAD",
          ready_to_purchase: f.readyToPurchase,
          data_import_source: "SALES ASSISTANT",
          website: f.website || "",
          place_id: practitionerInfo?.place_id || "",
        }
        const result = await putData(`/api/add_practitioner_to_chat/${practitionerInfo.id}`, {
          isDraft: isDraft,
          practitioner_data: newPractitionerInfo,
        });

        if (result?.error_msg) {
          if (!isDraft && result.error_msg === "Email already exists") {
            getPractitionerNotDraftByEmail(form.email).then((practitioner) => {
              // Ensure general_notes is set
              const practitionerWithNotes = {
                ...practitioner.practitioner,
                general_notes: practitioner.practitioner?.general_notes || ''
              };
              store.setCurrentPractitioner(practitionerWithNotes);
              setIsDuplicateModalOpen(true);
            });
            return;
          }
        }
      } else {
        const _status = !isDraft ? "LEAD-AWAITING-NETSUITE" :
          (isValid ? 'LEAD-READY2SUBMIT' : 'LEAD-INCOMPLETE');

        newPractitionerInfo = {
          address: `${f.address1}\n${f.address2}\n${f?.city}, ${(f?.state as any)?.value} ${f?.zipcode}`,
          address1: `${f.address1}`,
          address2: `${f.address2}`,
          phone: f.phone,
          name: `${f.firstname} ${f.lastname}`,
          primary_name: `${f.firstname} ${f.lastname}`,
          firstname: f.firstname,
          lastname: f.lastname,
          companyname: f.companyname,
          specialty: (f.specialtyType as any)?.value,
          practice_type: (f.practiceType as any)?.value,
          email: f.email,
          status: _status,
          data_source: "SALES ASSISTANT",
          fmc_email: store.impersonatedUser,
          latitude: practitionerInfo?.place?.geometry.location.lat || (f?.latLon ? f.latLon[0] : undefined),
          longitude: practitionerInfo?.place?.geometry.location.lng || (f?.latLon ? f.latLon[1] : undefined),
          city: f.city,
          state: (f.state as any)?.value,
          country: f.country || practitionerInfo?.place?.address_components?.find((a: any) => a?.types?.includes("country"))?.short_name,
          // building_name: practitionerInfo?.building_name,
          // sub_locality: practitionerInfo?.sub_locality,
          zipcode: f.zipcode,
          fmc: store.impersonatedUserName,
          fmc_netsuite_id: store.impersonatedUserNetsuiteID,
          rsd: store.impersonatedUserRsdName,
          rsd_email: store.impersonatedUserRsdEmail,
          stage: "LEAD",
          ready_to_purchase: f.readyToPurchase,
          data_import_source: "SALES ASSISTANT",
          website: f.website || "",
          place_id: practitionerInfo?.place_id || "",
        }

        result = await postData('/api/add_practitioner_to_chat', {
          isDraft: isDraft,
          practitioner_data: newPractitionerInfo,
        });
      }

      // Check if the response contains a practitioner (indicating a duplicate)
      // Only check for duplicates when creating a lead, not when saving a draft
      if (!isDraft && result?.error_msg) {
        // Store the duplicate practitioner and show confirmation modal
        if (result.error_msg === "Practitioner already exists") {
          getPractitionerNotDraftByEmail(form.email).then((practitioner) => {

            const practitionerWithNotes = {
              ...practitioner.practitioner,
              general_notes: practitioner.practitioner?.general_notes || ''
            };
            store.setCurrentPractitioner(practitionerWithNotes);
            setIsDuplicateModalOpen(true);
          });
          return; // Don't navigate away, show the confirmation modal first
        }
      }

      store.setPractitionersCarouselFilter("Geo-Verified");
      store.clearPractitionersCache();
      store.clearLeadsCache();
      const netsuiteLeadStr = "Sent Lead to Netsuite";
      trackClick(netsuiteLeadStr);
      onFormSubmitted();
    } catch (error) {
      console.error(error);
    }
  }



  const trackClick = (buttonName: string) => {
    const label = buttonName
    logEvent(label, { buttonName });
  };

  useEffect(() => {
    if (practitionerInfo?.ready_to_purchase != null) {
      setForm(f => ({
        ...f,
        readyToPurchase: Boolean(practitionerInfo.ready_to_purchase)
      }));
    }
  }, [practitionerInfo?.ready_to_purchase]);

  return (
    <Box pt={20} h="100%" style={{
      overflowY: "auto",
    }}>
      <ConfirmationModal
        isOpen={isConfirmationModalOpen}
        onClose={() => setIsConfirmationModalOpen(false)}
        onConfirm={() => {
          setIsConfirmationModalOpen(false);
          setAlreadyConfirmed(true);
        }}
        message="Once you send to Netsuite, you will not be able to edit details. Please make sure details are correct:"
        customRender={
          <div className={styles["confirmation-content"]}>
            <h3>Email <br />(Will check for duplicates next)</h3>
            <span>{form.email}</span>

            <h3>Address</h3>
            <span>{form.address1} </span>
            <span>{form.address2}</span>
            <span>{form.city}, {form.state.label} {form.zipcode}</span>

            <h3>Lat/Long</h3>
            <h3>(Required for Verified Check-Ins)</h3>
            {practitionerInfo?.place?.geometry.location.lat && practitionerInfo?.place?.geometry.location.lng && (
              <span>{practitionerInfo?.place?.geometry.location.lat}, {practitionerInfo?.place?.geometry.location.lng}</span>
            )}
            {practitionerInfo?.latitude && practitionerInfo?.longitude && (
              <span>{practitionerInfo?.latitude}, {practitionerInfo?.longitude}</span>
            )}

            <h3>Practitioner</h3>
            <span>{`${form.firstname} ${form.lastname}`}</span>
            <span>( &lt; 30 chars )</span>
          </div>}
      />
      <GeoValidationDrawer
        opened={!!geoValidationAction}
        onClose={() => setGeoValidationAction("")}
        addressToValidate={{
          administrativeArea: (form.state as any)?.value || "",
          locality: form.city || "",
          postalCode: form.zipcode || "",
          addressLines: [form.address1 || "", form.address2 || ""],
          regionCode: form.country || "",
        }}
        onConfirm={(a) => {
          if (a) {
            // Set flag to indicate this is a programmatic update from geo-validation
            isProgrammaticUpdate.current = true;
            const f = {
              ...form,
              state: { label: a.administrativeArea, value: a.administrativeArea },
              city: a.locality,
              address1: a.addressLines[0],
              address2: a.addressLines[1],
              zipcode: a.postalCode,
              latLon: a.latLon,
              country: form.country,
            };
            setForm(f);
            setIsGeoValidated(true); // Explicitly set to validated since we just validated
            if (geoValidationAction === "draft") {
              submitLead(true, f);
            }
          } else {
            // Set flag to indicate this is a programmatic update from geo-validation
            isProgrammaticUpdate.current = true;
            const f = {
              ...form,
              latLon: undefined
            };
            setForm(f);
            setIsGeoValidated(false); // Explicitly set to not validated since validation failed
            if (geoValidationAction === "draft") {
              submitLead(true, f);
            }
          }
          setGeoValidationAction("");
        }}
      />
      {onNavigate && (
        <LeftIcon onClick={() => onNavigate(practitionerInfo?.id ? "backedit" : "lead")} className={styles.leftIcon} />
      )}
      <div className={styles.container}>
        <div className={styles.content}>
          {/*<h2 className={styles["practitioner-name"]}>{practitionerInfo.place.name}</h2>*/}
          <form className={styles["form"]}>
            <div className={styles["form__side-by-side"]}>
              <div className={styles["form__input"]}>
                <label>
                  First Name<span className={styles.required}>*</span>
                </label>
                <input
                  className={formState.firstname ? styles["form__input--error"] : ""}
                  value={form.firstname}
                  onChange={(e) => setForm({ ...form, firstname: e.target.value })}
                  placeholder="Pamela"
                  type="text"
                />
              </div>
              <div className={styles["form__input"]}>
                <label>
                  Last Name<span className={styles.required}>*</span>
                </label>
                <input
                  className={formState.lastname ? styles["form__input--error"] : ""}
                  value={form.lastname}
                  onChange={(e) => setForm({ ...form, lastname: e.target.value })}
                  placeholder="Practitioner"
                  type="text"
                />
              </div>
            </div>
            <div className={styles["form__input"]}>
              <div className={styles["form__input-header"]}>
                <label className={styles["form__input-label"]}>
                  Company Name
                </label>
                <label className={styles["form__checkbox-label"]}>
                  <input
                    type="checkbox"
                    checked={form.readyToPurchase}
                    onChange={e => setForm({ ...form, readyToPurchase: e.target.checked })}
                  />
                  Ready to Purchase
                </label>
              </div>
              <input
                value={form.companyname}
                onChange={(e) => setForm({ ...form, companyname: e.target.value })}
                placeholder="Company Name"
                type="text"
              />
            </div>
            <div className={styles["form__input"]}>
              <div className={styles["form__input"]}>
                <label>
                  Country<span className={styles.required}>*</span>
                </label>
                <Select
                  value={COUNTRIES.find(country => country.value === form.country)}
                  className={styles["form__input--select"]}
                  onChange={(v: any) => setForm({ ...form, country: v.value })}
                  placeholder="United States"
                  styles={{
                    control: (baseStyles: any) => ({
                      ...baseStyles,
                      border: 'none',
                      borderBottom: '1px solid #ccc',
                      paddingLeft: 0,
                      marginLeft: 0,
                      color: '#4F7D9C',
                      boxShadow: 'none',
                      minHeight: "30px",
                      maxHeight: "30px",
                      '&:hover': {
                        boxShadow: 'none'
                      },

                    }),
                    dropdownIndicator: (baseStyles: any) => ({
                      ...baseStyles,
                      marginTop: "-5px",
                    }),
                    valueContainer: (baseStyles: any) => ({
                      ...baseStyles,
                      paddingLeft: 0,
                      marginLeft: 0,
                    }),
                    indicatorSeparator: () => ({
                      display: 'none'
                    })
                  }}
                  options={COUNTRIES.map((country) => ({
                    label: country.label,
                    value: country.value,
                  })) as []} />
              </div>
              <div className={styles["form__input-header"]}>
                <label className={styles["form__input-label"]}>
                  Address<span className={styles.required}>*</span>
                </label>
                <label className={styles["form__checkbox-label"]}>
                  <Button
                    onClick={() => handleGeoValidation()}
                    leftSection={isGeoValidated ? <CheckIcon size={10} /> : null}
                    variant="transparent">
                    Geo-Validate
                  </Button>
                </label>
              </div>

              <input
                className={formState.address1 ? styles["form__input--error"] : ""}
                value={form.address1}
                placeholder="123 Wellness Road"
                onChange={(e) => setForm({ ...form, address1: e.target.value })}
                type="text" />
              <input
                className={formState.address2 ? styles["form__input--error"] : ""}
                value={form.address2}
                onChange={(e) => setForm({ ...form, address2: e.target.value })}
                placeholder="Suite 456"
                type="text" />
            </div>
            {/* <div className={styles["form__side-by-side"]}>
              <div className={styles["form__input"]}>
                <label>Building Name</label>
              <input
                value={form.building_name}
                onChange={(e) => setForm({ ...form, building_name: e.target.value })}
                  placeholder="Baxter Building"
                  type="text" />
              </div>
              <div className={styles["form__input"]}>
                <label>Sub Locality</label>
              <input
                value={form.sub_locality}
                onChange={(e) => setForm({ ...form, sub_locality: e.target.value })}
                placeholder="Downtown"
                type="text" />
              </div>
            </div> */}
            <div className={styles["form__input"]}>
              <label>
                {form.country === "AU" ? "Suburb" : "City"}
              </label>
              <input
                className={formState.city ? styles["form__input--error"] : ""}
                value={form.city}
                onChange={(e) => setForm({ ...form, city: e.target.value })}
                placeholder="Palm Coast"
                type="text" />
            </div>
            <div className={styles["form__side-by-side"]}>
              <div className={styles["form__input"]}>
                <label>
                  {form.country === "CA" ? "Province/State" : form.country === "AU" ? "State/Territory" : "State"}
                </label>
                <Select
                  value={form.state}
                  className={styles["form__input--select"]}
                  onChange={(v: any) => setForm({ ...form, state: v })}
                  placeholder="FL"
                  menuPlacement="top"
                  styles={{
                    control: (baseStyles: any) => ({
                      ...baseStyles,
                      border: 'none',
                      borderBottom: '1px solid #ccc',
                      paddingLeft: 0,
                      marginLeft: 0,
                      color: '#4F7D9C',
                      boxShadow: 'none',
                      minHeight: "30px",
                      maxHeight: "30px",
                      '&:hover': {
                        boxShadow: 'none'
                      },

                    }),
                    dropdownIndicator: (baseStyles: any) => ({
                      ...baseStyles,
                      marginTop: "-5px",
                    }),
                    valueContainer: (baseStyles: any) => ({
                      ...baseStyles,
                      paddingLeft: 0,
                      marginLeft: 0,
                    }),
                    indicatorSeparator: () => ({
                      display: 'none'
                    })
                  }}
                  options={regions.map((s) => ({
                    label: s.label,
                    value: s.value,
                  })) as []} />
              </div>
              <div className={styles["form__input"]}>
                <label>
                  {form.country === "US" ? "Zipcode" : "Postal Code"}<span className={styles.required}>*</span>
                </label>
                <input
                  className={formState.zipcode ? styles["form__input--error"] : ""}
                  value={form.zipcode}
                  onChange={(e) => setForm({ ...form, zipcode: e.target.value })}
                  placeholder="01234"
                  type="text"
                />
              </div>
            </div>
            <div className={styles["form__input"]}>
              <label>
                Phone<span className={styles.required}>*</span>
              </label>
              <input
                className={formState.phone ? styles["form__input--error"] : ""}
                value={form.phone}
                onChange={(e) => setForm({ ...form, phone: phoneMask(e.target.value, form.country) })}
                placeholder="(888)888-8888"
                type="text" />
            </div>

            <div className={styles["form__input"]}>
              <label>
                Email<span className={styles.required}>*</span>
              </label>
              <input
                className={formState.email ? styles["form__input--error"] : ""}
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                placeholder="email@practitioner.com"
                type="text" />
            </div>
            <div className={styles["form__input"]}>
              <label>
                Speciality Type
              </label>
              <Select
                value={form.specialtyType}
                onChange={(v: any) => setForm({ ...form, specialtyType: v })}
                placeholder="Choose Practitioner Specialty (Optional)"
                menuPlacement="top"
                styles={{
                  control: (baseStyles: any) => ({
                    ...baseStyles,
                    border: 'none',
                    borderBottom: '1px solid #ccc',
                    paddingLeft: 0,
                    marginLeft: 0,
                    color: '#4F7D9C',
                    boxShadow: 'none',
                    '&:hover': {
                      boxShadow: 'none'
                    }
                  }),
                  valueContainer: (baseStyles: any) => ({
                    ...baseStyles,
                    paddingLeft: 0,
                    marginLeft: 0,
                  }),
                  indicatorSeparator: () => ({
                    display: 'none'
                  })
                }}
                options={MOCK_SPECIALTIES.map((sp) => ({
                  label: sp,
                  value: sp,
                })) as []} />
            </div>
            <div className={styles["form__input"]}>
              <label>
                Practice Type
              </label>
              <Select
                value={form.practiceType}
                onChange={(v: any) => setForm({ ...form, practiceType: v })}
                placeholder="Choose Practice Type (Optional)"
                menuPlacement="top"
                styles={{
                  control: (baseStyles: any) => ({
                    ...baseStyles,
                    border: 'none',
                    borderBottom: '1px solid #ccc',
                    paddingLeft: 0,
                    marginLeft: 0,
                    color: '#4F7D9C',
                    boxShadow: 'none',
                    '&:hover': {
                      boxShadow: 'none'
                    }
                  }),
                  valueContainer: (baseStyles: any) => ({
                    ...baseStyles,
                    paddingLeft: 0,
                    marginLeft: 0,
                  }),
                  indicatorSeparator: () => ({
                    display: 'none'
                  })
                }}
                options={MOCK_PRACTICE_TYPE.map((pt) => ({
                  label: pt,
                  value: pt,
                })) as []} />
            </div>
            <div className={styles["form__input"]}>
               <label>
                Website
               </label>
               <input
                value={form.website}
                onChange={(e) => setForm({ ...form, website: e.target.value })}
                placeholder="https://www.example.com"
                type="text"
               />
            </div>
            <div className={styles["buttons-container"]}>
              <button
                disabled={!isValid}
                onClick={() => submitLead(false)}
                className={styles["button"]}
                type="button">
                Send to Netsuite
                <span>CREATE LEAD</span>
              </button>
              <button
                className={styles["draft-button"]}
                onClick={() => {
                  const leadstr = "Saved lead draft";
                  trackClick(leadstr);
                  if (isGeoValidated) {
                    // already have valid lat/lng → skip the drawer and save draft immediately
                    submitLead(true);
                  } else {
                    // not yet validated → open the drawer as before
                    handleGeoValidation("draft");
                  }
                }}
                type="button">
                Save Draft
                <span>IN SALES ASSISTANT</span>
              </button>
            </div>
          </form>
        </div>
        <DuplicateConfirmationModal
          isOpen={isDuplicateModalOpen}
          onClose={handleCloseDuplicateModal}
          onOpen={handleOpenBaseballCard}
        />
      </div>
      <SlideUpMenus
        isOpen={isSlideUpMenusOpen}
        selectedView="baseballcard"
        selectedTab={Tab.SUMMARY}
        setIsOpen={setIsSlideUpMenusOpen}
      />
    </Box>
  );
};

export default LeadForm;